import { convertListingTypeToValuesForTracking } from '@/helpers/GTM/GTMHelpers';
import { GTMPageType, InteractionEvent } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { isShowAgencyAgent } from '@/resultlist/LayoutSolutionResultListPage.tracking';
import { ListingItem } from '@smg-real-estate/hg-search-libs';

interface SearchClickThroughTrackingMeta {
  listingItem: ListingItem;
  listingCardSize?: string;
  positionOverall: number;
  gtmPageType: GTMPageType;
}

export function trackSearchClickThrough(trackingMeta: SearchClickThroughTrackingMeta): void {
  trackEventHarmonized(InteractionEvent.SEARCH_CLICKTROUGH, {
    h_event_category_006: 'search_clickthrough',
    h_list_name_086: 'search_results',
    h_event_action_007: trackingMeta.gtmPageType,
    h_position_on_list_overall_283: trackingMeta.positionOverall,
    h_event_label_008: trackingMeta.listingItem.id,
    h_list_item_clicked_id_085: trackingMeta.listingItem.id,
    h_listing_lister_id_154: trackingMeta.listingItem.listing.lister?.id,
    h_list_item_vas_090: convertListingTypeToValuesForTracking(
      trackingMeta.listingItem.listingType?.type,
    ),
    h_listing_layout_124:
      trackingMeta.listingCardSize ?? trackingMeta.listingItem.listingCard?.size,
    h_listing_package_name_108:
      trackingMeta.listingItem.listerBranding?.subscriptionType ?? undefined,
    h_listing_completeness_score_127:
      trackingMeta.listingItem.listingScores?.listingCompletenessScore,
    h_list_item_agency_pic_176: isShowAgencyAgent(trackingMeta.listingItem) ? 1 : 0,
  });
}
